var currencyTypeSymbols = {
    'aud': '&#36;',
    'cad': '&#36;',
    'eur': '&#128;',
    'gbp': '&#163;',
    'rub': 'руб',
    'usd': '&#36;',
    'jpy': '&#165;'
};

function getCurrencyTypeSymbol(currencyType) {
    if (currencyTypeSymbols.hasOwnProperty(currencyType)) {
        return currencyTypeSymbols[currencyType];
    }
    return '?';
}

export default {
    'getCurrencySymbol': function getCurrencySymbol(currencyType) {
        return getCurrencyTypeSymbol(currencyType);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/util/CurrencyUtil.js
// module id = 1798
// module chunks = 0